import { 
    GET_TRANSFER_GRID_COUNT, 
    GET_TRANSFER_GRID_DATA, 
    SET_TRANSFER_GRID_COUNT, 
    SET_TRANSFER_GRID_DATA, 
    IS_MY_ORDERS_GRID_LOADING,
    IS_MY_ORDERS_GRID_COUNTS_LOADING
} from "./TransferGridType";

const getTransferGridData = (val: string) => ({
    type: GET_TRANSFER_GRID_DATA,
    val: val
});

const setTransferGridData = (transferGridData: any) => ({
    type: SET_TRANSFER_GRID_DATA,
    transferGridData: transferGridData
});

const getTransferGridCount = () => ({
    type: GET_TRANSFER_GRID_COUNT
});

const setTransferGridCount = (gridCount: any) => ({
    type: SET_TRANSFER_GRID_COUNT,
    gridCount
});

const setIsMyOrdersGridLoading = (flag: any) => ({
    type: IS_MY_ORDERS_GRID_LOADING,
    flag
});

const setIsMyOrdersGridCountsLoading = (flag: any) => ({
    type: IS_MY_ORDERS_GRID_COUNTS_LOADING,
    flag
});

export {
    getTransferGridData,
    setTransferGridData,
    getTransferGridCount,
    setTransferGridCount,
    setIsMyOrdersGridLoading,
    setIsMyOrdersGridCountsLoading
}
